export default __webpack_public_path__ + "static/media/162.cbacafcc.gif";